import { z } from 'zod';
import { materialAlterCodesForSalesDocument } from '../materials/getMaterialAlterCodesWithConditions';

const discountSchema = z.object({
  discountId: z.string(),
  discountSequence: z.number(),
  discountType: z.number(),
  value: z.number(),
});

z;

export const getRangeDetailsByCustomerIdSchema = z.array(
  z.object({
    materialAlterCode: materialAlterCodesForSalesDocument,
    quantity: z.number(),
    price: z.number(),
    vatFactor: z.number(),
    vatFactorId: z.string(),
    discounts: z.array(discountSchema).optional(),
  })
);
